import { lazy } from 'react';

// project imports
import UserMainLayout from 'layout/UserMainLayout';
import AttendanceAdminPage from 'modules/admin/attendance/pages/AttendanceAdminPage';
import AdminCostCenterPage from 'modules/admin/cost_center/pages/AdminCostCenterPage';
import AdminDashboardPage from 'modules/admin/dashboard/pages/adminDashboardPage';
import AdminDepartmentPage from 'modules/admin/department/pages/AdminDepartmentPage';
import AdminCreateEmployeePage from 'modules/admin/employee/pages/AdminCreateEmployeePage';
import AdminEditEmployeePage from 'modules/admin/employee/pages/AdminEditEmployeePage';
import AdminEmployeePage from 'modules/admin/employee/pages/AdminEmployeePage';
import AdminLeavePage from 'modules/admin/leave/pages/AdminLeavePage';
import LeaveConfigPage from 'modules/admin/leave_config/pages/LeaveConfigPage';
import AdminLeaveFlow from 'modules/admin/leave_flow/pages/AdminLeaveFlowPage';
import AdminSubCompanyPage from 'modules/admin/sub_company/pages/AdminSubCompanyPage';
import AdminWorkCalendar from 'modules/admin/work_calendar/pages/AdminWorkCalendar';
import AdminWorkCategoryPage from 'modules/admin/work_category/pages/AdminWorkCategoryPage';
import Loadable from 'ui-component/Loadable';

const ExportRequestPage = Loadable(lazy(() => import('modules/admin/export_request/pages/ExportRequestPage')));
const DashboardPage = Loadable(lazy(() => import('modules/dashboard/pages/DashboardPage')));
const CompanyAssetPage = Loadable(lazy(() => import('modules/company-asset/pages/CompanyAssetPage')));
const LatePage = Loadable(lazy(() => import('modules/late/pages/LatePage')));
const CreateLatePage = Loadable(lazy(() => import('modules/late/pages/CreateLatePage')));
const DivisionPage = Loadable(lazy(() => import('modules/division/pages/DivisionPage')));
const BankPage = Loadable(lazy(() => import('modules/bank/pages/BankPage')));
const TitlePage = Loadable(lazy(() => import('modules/title/pages/TitlePage')));

const AdminRoutes = {
    path: 'admin',
    element: <UserMainLayout />,
    children: [
        {
            path: '',
            element: <AdminDashboardPage />
        },
        {
            path: 'employees',
            children: [
                {
                    path: '',
                    element: <AdminEmployeePage />
                },
                {
                    path: 'create',
                    element: <AdminCreateEmployeePage />
                },
                {
                    path: 'edit/:id',
                    element: <AdminEditEmployeePage />
                }
            ]
        },
        {
            path: 'export-request',
            element: <ExportRequestPage />
        },
        {
            path: 'company-asset',
            element: <CompanyAssetPage />
        },
        {
            path: 'attendances',
            element: <AttendanceAdminPage />
        },
        {
            path: 'work_categories',
            element: <AdminWorkCategoryPage />
        },
        {
            path: 'cost_center',
            element: <AdminCostCenterPage />
        },
        {
            path: 'sub_company',
            element: <AdminSubCompanyPage />
        },
        {
            path: 'department',
            element: <AdminDepartmentPage />
        },
        {
            path: 'late',
            element: <LatePage />
        },
        {
            path: 'late/create',
            element: <CreateLatePage />
        },
        {
            path: 'division',
            element: <DivisionPage />
        },
        {
            path: 'bank',
            element: <BankPage />
        },
        {
            path: 'title',
            element: <TitlePage />
        },
        {
            path: 'leave_flow',
            children: [
                {
                    path: '',
                    element: <AdminLeaveFlow />
                }
            ]
        },
        {
            path: 'leave',
            children: [
                {
                    path: '',
                    element: <AdminLeavePage />
                }
            ]
        },
        {
            path: 'holiday-calendar',
            children: [
                {
                    path: '',
                    element: <AdminWorkCalendar />
                }
            ]
        },
        {
            path: 'leave_config',
            children: [
                {
                    path: '',
                    element: <LeaveConfigPage />
                }
            ]
        }
    ]
};

export default AdminRoutes;
